import { ComponentProps } from 'react';
import { useTranslation } from 'next-i18next';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Heading, Button, Modal, ModalContent } from '@restworld/ui-ds-base';
import { cn, useModal } from '@restworld/utils-common';

// Sits on the purple recommendations panel: white borderless link-style button (matches
// production's ghost + white). ghost forces `!text-neutral-700`, so white is forced with `!`,
// and the DS tints the icon dark for ghost, so it's forced white here too.
const WhiteInfoIcon = (props: ComponentProps<'svg'>) => (
  <InformationCircleIcon {...props} className={cn(props.className, '!text-white')} />
);

export const WhyProposedApplications = () => {
  const { open, close, show } = useModal();
  const { t } = useTranslation();
  const titleText = t('job-application-page:why_see_proposed_jobs');
  return (
    <>
      <Button
        onClick={() => open()}
        className={'!p-0 font-semibold lg:text-sm text-sm lg:leading-4 leading-4 !text-white'}
        variant="ghost"
        StartIcon={WhiteInfoIcon}
      >
        {t('job-application-page:why_proposed_jobs')}
      </Button>
      <Modal open={show} onOpenChange={(v) => !v && close()}>
        <ModalContent className="w-full md:max-w-[31.875rem] md:min-w-[31.875rem]">
          <Wrapper>
            <Heading size={2} className="hidden lg:block">
              {titleText}
            </Heading>
            <Heading size={3} className="lg:hidden">
              {titleText}
            </Heading>
            <Heading size={5} weight="normal" color="muted-foreground">
              {t('job-application-page:why_see_proposed_jobs_description')}
            </Heading>
            <Button className={'mt-8'} fullwidth variant="primary" onClick={close}>
              {t('common:i_understand')}
            </Button>
          </Wrapper>
        </ModalContent>
      </Modal>
    </>
  );
};
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col items-start justify-start gap-4', className)} {...props} />
);
